import { IPropagation, IPropagationStd } from "./constants";

export const actionTypes = {
  GET_PROPAGATIONS: "GET_PROPAGATIONS",
  GET_PROPAGATIONS_SUCCESS: "GET_PROPAGATIONS_SUCCESS",
  GET_PROPAGATIONS_FAILURE: "GET_PROPAGATIONS_FAILURE",
  UPDATE_PROPAGATION: "UPDATE_PROPAGATION",
  POST_UPDATE: "POST_UPDATE",
  POST_UPDATE_SUCCESS: "POST_UPDATE_SUCCESS",
  POST_UPDATE_FAILURE: "POST_UPDATE_FAILURE",
  POST_DELETE: "POST_DELETE",
  POST_DELETE_SUCCESS: "POST_DELETE_SUCCESS",
  POST_DELETE_FAILURE: "POST_DELETE_FAILURE",
};

export const getPropagationsAction = () => ({
  type: actionTypes.GET_PROPAGATIONS,
});

export const getPropagationsSuccess = (response: IPropagation[]) => ({
  type: actionTypes.GET_PROPAGATIONS_SUCCESS,
  payload: response,
});

export const getPropagationsFailure = (err: Error) => ({
  type: actionTypes.GET_PROPAGATIONS_FAILURE,
  err,
});

export const updatePropagation = (sourceTargetId: string, sourceIdentitySystemId: string,
  destTargetId: string, destIdentitySystemId: string, index: number) => ({
  type: actionTypes.UPDATE_PROPAGATION,
  payload: { index,
    data: {
      sourceTargetId,
      sourceIdentitySystemId,
      destTargetId,
      destIdentitySystemId,
    },
  },
});

export const sendUpdateAction = (data: IPropagationStd[]) => ({
  type: actionTypes.POST_UPDATE,
  payload: data,
});

export const postUpdatePropagationsSuccess = (response: any) => ({
  type: actionTypes.POST_UPDATE_SUCCESS,
  payload: response,
});

export const postUpdatePropagationsFailure = (err: Error) => ({
  type: actionTypes.POST_UPDATE_FAILURE,
  err,
});

export const postDeleteAction = (ids: string[]) => ({
  type: actionTypes.POST_DELETE,
  payload: ids,
});

export const postDeletePropagationsSuccess = (response: any) => ({
  type: actionTypes.POST_DELETE_SUCCESS,
  payload: response,
});

export const postDeletePropagationsFailure = (err: Error) => ({
  type: actionTypes.POST_DELETE_FAILURE,
  err,
});